import { coppelIntegracionActiva } from './constants'
import { esIdBancoCoppel, esNombreBancoCoppel } from './bancos'

/** Título en tarjetas Productos / Solicitados (como mock BanCoppel). */
export const COPPEL_PRODUCTO_NOMBRE_UI = 'HIPOTECA DIGITAL'

let coppelLogoInstitucion = ''

/** Guarda logo Abacus (`institution_logo`) de la última cotización Coppel en sesión. */
export function setCoppelLogoInstitucion(url) {
  if (url && String(url).trim()) {
    coppelLogoInstitucion = String(url).trim()
  }
}

export function getCoppelLogoInstitucion() {
  return coppelLogoInstitucion
}

export function esCoppelSolicitud(entidad) {
  if (!coppelIntegracionActiva()) return false
  if (!entidad) return false
  const bancoId = entidad.BancoId != null ? entidad.BancoId : entidad.IdBanco
  if (esIdBancoCoppel(bancoId)) return true
  const nombre = entidad.Banco != null ? entidad.Banco : entidad.NombreBanco || entidad.Variante
  return esNombreBancoCoppel(nombre)
}

/** Nombre visible en pestaña Productos (no el nombre interno del catálogo SOC). */
export function nombreProductoCoppelUi(entidad) {
  if (!entidad) return ''
  if (esCoppelSolicitud(entidad)) return COPPEL_PRODUCTO_NOMBRE_UI
  return entidad.Variante || entidad.Producto || ''
}

export function logoSocSrc(logo, logoEsUrl) {
  if (!logo) return ''
  const str = String(logo).trim()
  if (!str || str === 'null') return ''
  if (logoEsUrl || /^https?:\/\//i.test(str)) return str
  return 'https://preprodcotizador.socasesores.com/uploads/' + str
}

/** Src del logo en Solicitados: uploads SOC o URL Abacus (sin /uploads/null). */
export function logoSolicitudSrc(solicitud) {
  if (!solicitud) return ''
  const logo = solicitud.BancoLogo || solicitud.Logo
  const desdeSoc = logoSocSrc(logo, solicitud.LogoEsUrl)
  if (desdeSoc) return desdeSoc
  if (esCoppelSolicitud(solicitud)) {
    return getCoppelLogoInstitucion()
  }
  return ''
}

/** Copia logo de ítems cotizados a solicitudes Coppel (DameCaso no trae URL Abacus). */
export function enriquecerSolicitudesCoppelDesdeItems(solicitudes, items, estaEnSolicitudesFn) {
  if (!Array.isArray(solicitudes) || !Array.isArray(items)) return solicitudes
  solicitudes.forEach(function(s) {
    if (!esCoppelSolicitud(s)) return
    const item = items.find(function(i) {
      return esCoppelSolicitud(i) && estaEnSolicitudesFn(i, [s])
    })
    if (item && item.Logo) {
      s.BancoLogo = item.Logo
      s.LogoEsUrl = !!item.LogoEsUrl || /^https?:\/\//i.test(String(item.Logo))
    } else if (getCoppelLogoInstitucion()) {
      s.BancoLogo = getCoppelLogoInstitucion()
      s.LogoEsUrl = true
    }
  })
  return solicitudes
}
